<div class="column-properties-container">
  <div class="header">
    <p>{{ translation?.title }}</p>
  </div>
  <div class="body">
    <div class="row">
      <div class="expression-dropdown">
        <abc-drop-down-box
          #expressionDropDownBox
          label="{{ translation?.expression }}"
          [width]="'100%'"
          [(value)]="column.data.expression"
          [acceptCustomValue]="false"
          (onValueChanged)="refresh()"
          [buttons]="expressionDropDownBoxButtons"
        ></abc-drop-down-box>
      </div>
    </div>
    <div class="row">
      <abc-text-box
        [valueChangeEvent]="'input'"
        [width]="'75%'"
        label="{{ translation?.alias }}"
        [(value)]="column.data.alias"
        (onValueChanged)="changeAlias($event)"
      ></abc-text-box>
      <abc-check-box
        [width]="'25%'"
        text="{{ translation?.visible }}"
        [(value)]="column.data.columnProperties.visible"
        (onValueChanged)="refresh()"
      ></abc-check-box>
    </div>
    <div class="row">
      <abc-text-box
        [width]="'75%'"
        label="{{ translation?.formatExpression }}"
        [valueChangeEvent]="'input'"
        [(value)]="column.data.columnProperties.formatExpression"
        (onValueChanged)="refresh()"
      ></abc-text-box>
      <abc-check-box
        [width]="'25%'"
        [disabled]="!column.data.columnProperties.formatExpression?.length"
        [(value)]="column.data.columnProperties.culture"
        (onValueChanged)="refresh()"
        text="{{ translation?.neutralCulture }}"
      ></abc-check-box>
    </div>
    <div class="row">
      <abc-drop-down-box
        label="{{ translation?.sorting }}"
        [(value)]="column.data.columnProperties.sorting"
        (onValueChanged)="refresh()"
        [width]="'calc(calc(75% / 2) - 5px)'"
        #sortingDropDownBox
      ></abc-drop-down-box>
      <abc-drop-down-box
        label="{{ translation?.emptyFields }}"
        [(value)]="column.data.columnProperties.spacing"
        (onValueChanged)="refresh()"
        [dataSource]="spacingDropDownDataSource"
        [valueExpr]="'value'"
        [displayExpr]="'value'"
        [width]="'calc(calc(75% / 2) - 5px)'"
      ></abc-drop-down-box>
      <abc-check-box
        [width]="'25%'"
        text="{{ translation?.filter }}"
        [(value)]="column.data.columnProperties.filter"
        (onValueChanged)="refresh()"
      ></abc-check-box>
    </div>
  </div>
</div>
